import { ChangeDetectionStrategy, Component } from '@angular/core';
import { HeroLayout1Component } from '@components/hero/components/hero-layout-1';
import { HeroLayout2Component } from '@components/hero/components/hero-layout-2';
import { HeroLayout3Component } from '@components/hero/components/hero-layout-3';
import { HeroLayout4Component } from '@components/hero/components/hero-layout-4';
import { HeroLayout } from '@components/hero/config';
import { ComponentLoaderAbstract } from '@services/component-loader';
import { Layout } from '@shared/models';

@Component({
  selector: 'app-hero',
  imports: [HeroLayout1Component, HeroLayout2Component, HeroLayout3Component, HeroLayout4Component],
  templateUrl: './hero.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeroComponent extends ComponentLoaderAbstract<Layout<HeroLayout>> {
  readonly layout = HeroLayout;
}
